export const SELECTORS = {
  CONTAINER: 'js-free-gift-opt-in',
  LOADING: 'js-free-gift-opt-in-loading',
  SUCCESS: 'js-free-gift-opt-in-success',
  ERROR: 'js-free-gift-opt-in-error',
  ERROR_TEXT: 'js-free-gift-opt-in-error-text',
  RETRY_BUTTON: 'js-free-gift-opt-in-retry-button',
  EXPIRED: 'js-free-gift-opt-in-expired'
};
